'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvailabilityLink = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _analyticsEventComposers = require('@bibliocommons/analytics-event-composers');

var _utilsAnalytics = require('@bibliocommons/utils-analytics');

require('../styles/AvailabilityLink.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var composeViewAvailabilityEvent = _analyticsEventComposers.availabilityEventComposer.composeViewAvailabilityEvent;

var AvailabilityLink = exports.AvailabilityLink = function (_BcReactComponent) {
  _inherits(AvailabilityLink, _BcReactComponent);

  function AvailabilityLink(props) {
    _classCallCheck(this, AvailabilityLink);

    var _this = _possibleConstructorReturn(this, (AvailabilityLink.__proto__ || Object.getPrototypeOf(AvailabilityLink)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(AvailabilityLink, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          availabilityDetailActions = _props.availabilityDetailActions,
          metadataId = _props.metadataId,
          status = _props.status;


      (0, _utilsAnalytics.sendAnalyticsEvents)(composeViewAvailabilityEvent(status));

      if (!this.context.isWidget) {
        availabilityDetailActions.getAvailability(metadataId);
      }
    }
  }, {
    key: 'getLinkUrl',
    value: function getLinkUrl(metadataId) {
      if (this.context.isWidget) {
        return '/v2/availability/' + metadataId;
      }
      var router = this.props.router;

      var search = router ? router.location.search : '';
      var pathname = router ? router.location.pathname : '';
      return pathname + '/availability/' + metadataId + search;
    }
  }, {
    key: 'getExtraLinkOptions',
    value: function getExtraLinkOptions() {
      if (this.context.isWidget) {
        return {
          target: '_top'
        };
      }

      return {};
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          metadataId = _props2.metadataId,
          title = _props2.title,
          format = _props2.format,
          status = _props2.status,
          availabilityLocationType = _props2.availabilityLocationType,
          intl = _props2.intl;


      return _react2.default.createElement(
        'span',
        { className: 'cp-availability-trigger' },
        _react2.default.createElement(
          _reactRouter.Link,
          _extends({ 'data-key': 'bib-availability-link', to: this.getLinkUrl(metadataId), onClick: this.handleClick }, this.getExtraLinkOptions()),
          _react2.default.createElement(
            'span',
            { 'aria-hidden': 'true' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Availability.detailsLink' })
          ),
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'Availability.ada_detailsLink',
              values: { title: title,
                format: intl.formatMessage({ id: 'FORMAT.' + format.toLowerCase() }),
                status: status ? intl.formatMessage({ id: 'circ_' + status.toLowerCase() }, { location: availabilityLocationType }) : '' } })
          )
        )
      );
    }
  }]);

  return AvailabilityLink;
}(_baseBcReactComponent2.default);

AvailabilityLink.propTypes = {
  metadataId: _react.PropTypes.string.isRequired,
  router: _reactRouter.routerShape,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
  title: _react.PropTypes.string.isRequired,
  format: _react.PropTypes.string.isRequired,
  status: _react.PropTypes.string,
  availabilityLocationType: _react.PropTypes.string,
  intl: _reactIntl.intlShape
};

AvailabilityLink.contextTypes = {
  isWidget: _react.PropTypes.bool
};

exports.default = (0, _reactRouter.withRouter)((0, _reactIntl.injectIntl)(AvailabilityLink));


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-link/lib/components/AvailabilityLink.component.js
// module id = 1004
// module chunks = 1